<template>
  <div>
    
    <div>
        <section>
           
            <div class="search-container">
               <h3>培训报名</h3>
                <div >
                    <el-card class="box-card">
                      <div slot="header" class="clearfix">
                        <span>请填写您的报名信息</span>
                      </div>
                      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
                        <el-form-item label="姓名" prop="username">
                          <el-input v-model="ruleForm.username" placeholder="请输入您的姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="身份证号码" prop="identificationcard">
                          <el-input v-model="ruleForm.identificationcard" placeholder="请输入您的身份证号码"></el-input>
                        </el-form-item>
                        <el-form-item label="手机号码" prop="phone">
                          <el-input v-model="ruleForm.phone" placeholder="请输入您的手机号码"></el-input>
                        </el-form-item>
                        <el-form-item label="地址" required>
                          <el-cascader
                            style="margin-right: 1%;width:100%"
                            placeholder="请点击选择省市"
                            :options="options"
                            @change="handleChange"
                          ></el-cascader>
                        </el-form-item>
                        <el-form-item label="行业分类" required>
                           <el-select v-model="selBigCourseType" placeholder="请选择行业分类" style="width: 100%" @change="handleChangeBigType($event,BigCourseTypes)">
                              <el-option
                                v-for="item in BigCourseTypes"
                                :key="item.name"
                                :label="item.name"
                                :value="item._id">
                              </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="报名专业" v-show="selBigCourseType" v-if="!global.isPhone()" required>
                           <el-select v-model="ruleForm.coursetypeid" placeholder="请选择" style="width: 100%" @change="handleChangeType($event,CourseTypes)" filterable>
                              <el-option
                                v-for="item in CourseTypes"
                                :key="item.name"
                                :label="item.name"
                                :value="item._id">
                              </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="报名专业" v-show="selBigCourseType" v-else required>
                           <el-autocomplete
                              style="width: 100%"
                                v-model="state"
                                :fetch-suggestions="querySearchAsync"
                                placeholder="请输入内容"
                                @select="handleSelect"
                              ></el-autocomplete>
                        </el-form-item>
                        <el-form-item label="报名级别" required>
                           <el-select v-model="ruleForm.level" placeholder="请选择" style="width: 100%"  >
                              <el-option
                                v-for="item in ['初级','中级','高级','专家']"
                                :key="item"
                                :label="item"
                                :value="item">
                              </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item class="submit">
                          <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                        </el-form-item>
                      </el-form>  
                    </el-card>
                </div>
            </div>
        </section>
	</div>
	<center>
		<div style="font-size: 10px">Copyright&copy;jhai 版权所有</div>
	</center>
  </div>
</template>

<script>
import global from "@/components/PublicComs/Common.vue";
export default {
  props: {},
  components: {},
  data () {
    return {
        global,
        cardid:"",
        ruleForm:{},
         rules: {
          username: [
            { required: true, message: '请输入您的姓名', trigger: 'blur' }
          ],
          identificationcard: [
            { required: true, message: '请输入身份证号码', trigger: 'change' }
          ],
          phone: [
            {required: true, message: '请输入手机号码', trigger: 'change' }
          ],
          address: [
            {required: true, message: '请输入地址', trigger: 'change' }
          ],
          coursetype: [
            {  required: true, message: '请选择报名专业', trigger: 'change' }
          ],
          level: [
            { required: true, message: '请选择报名级别', trigger: 'change' }
          ]
        },
        // 地址选择器
        options: [],
        selectedOptions: [],
        cityArr: [], //城市列表
        areaArr: [], //区县列表
        province: "", //省
        city: "", //市
        area: "", // 区县,
        provinceCityArea: "", //选择器选择的省市区
        CourseTypes:[], //
        BigCourseTypes:[],
        selBigCourseType:'',
        selCourseType:'',     
        inittype:'',   
        serachFlag:false,
        state:''
    };
  },

  created() {},

  methods: {
     querySearchAsync(queryString, cb) {
      var restaurants = this.CourseTypes;
      var results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
      console.log(results)
      cb(results);
    },
    createStateFilter(queryString) {
      return (state) => {
        return (state.name.toLowerCase().indexOf(queryString.toLowerCase()) >= 0);
      };
    },
    handleSelect(item) {
      this.ruleForm.coursetype = item.name;
      this.ruleForm.coursetypeid = item._id;
    },
    handleChangeBigType(value,types){
      for (var i = 0; i < types.length; i++){
        if (types[i]._id==value)
        { 
          this.ruleForm.bigcoursetype = types[i].name;
          this.ruleForm.bigcoursetypeid = types[i]._id;
        }
      }
    },
    handleChangeType(value,types){
      for (var i = 0; i < types.length; i++){
        if (types[i]._id==value)
        { 
          this.ruleForm.coursetype = types[i].name;
        }
      }
    },
      initDistPicker() {
      // console.log("initDistrictsPicker");
      let self = this;
      this.$axios.get("/static/jsc-json/districts.json").then(function(respones) {
        // console.log("respones==>", respones);
        let distData = respones.data;
        let options = [];
        // 省
        for (var provinceKy in distData["100000"]) {
          let optProvinceItem = {
            value: provinceKy,
            label: distData["100000"][provinceKy]
          };
          if (distData[provinceKy]) {
            // 市
            for (var cityKy in distData[provinceKy]) {
              optProvinceItem.children = optProvinceItem.children
                ? optProvinceItem.children
                : [];
              let optCityItem = {
                value: cityKy,
                label: distData[provinceKy][cityKy]
              };
              optProvinceItem.children.push(optCityItem);
            }
          }
          options.push(optProvinceItem);
        }
        self.distData = distData;
        self.options = options;
      });
      },
       submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.$axios.post(`/api/signUpOrders`,this.ruleForm).then((res) => {
              if (res.data) {
                let user = res.data.data;
                this.$router.push(`/SignUpResult?id=${user._id}`);
                return;
              }
            });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      //选择地区
      handleChange(value) {
        let self = this;
        //获取省名
        self.options.map((item, index) => {
          if (item.value == value[0]) {
            self.cityArr = item.children; //存储城市列表
            self.province = item.label;
          }
        });
        //获取市名
        self.cityArr.map((item, index) => {
          if (item.value == value[1]) {
            self.areaArr = item.children; //存储区县列表
            self.city = item.label;
          }
        });
        self.provinceCityArea = self.province + self.city ;
        // console.log("self.provinceCityArea", self.provinceCityArea);
        this.ruleForm.address=self.provinceCityArea;
        console.log("self.ruleForm.address", this.ruleForm.address)
        // console.log(this.form.qyzcd)
      },
  },

  computed: {},

  mounted() {
    this.initDistPicker();
    let bigtype = this.$route.query.bigtype;
    this.inittype = this.$route.query.type;
    this.$axios.get(`/api/bigCourseTypes`).then(res => {
      if(res.data){
        this.BigCourseTypes = res.data.data;
        if(bigtype) 
        {
            for(let i = 0; i < this.BigCourseTypes.length;i++)
            {
              if(this.BigCourseTypes[i].name ==bigtype)
              {
                this.selBigCourseType = this.BigCourseTypes[i]._id;
                this.ruleForm.bigcoursetype = this.BigCourseTypes[i].name;
                this.ruleForm.bigcoursetypeid = this.BigCourseTypes[i]._id;
                break;
              }
            }
            this.$axios.get(`/api/CourseTypes?bigtype=${this.selBigCourseType}`).then(res => {
              if(res.data){
                this.CourseTypes = res.data.data;
                let  tmpCourseTypes = [];
                for(var i = 0; i < this.CourseTypes.length; i++)
                {
                  if(this.CourseTypes[i].price) 
                  {
                    this.CourseTypes[i].value = this.CourseTypes[i].name;
                    tmpCourseTypes.push(this.CourseTypes[i]);
                  }
                  if(this.CourseTypes[i].name==this.inittype)
                  {
                    
                    this.ruleForm.coursetypeid = this.CourseTypes[i]._id;
                    this.state = this.inittype;
                    this.$forceUpdate()
                  }
                }
                this.CourseTypes = tmpCourseTypes;
              }
            });
        }
        
      }
    });
  },
  watch: {
    selBigCourseType(newVal){
      this.$axios.get(`/api/CourseTypes?bigtype=${newVal}`).then(res => {
        if(res.data){
          this.CourseTypes = res.data.data;
          let  tmpCourseTypes = [];
          for(var i = 0; i < this.CourseTypes.length; i++)
          {
            if(this.CourseTypes[i].price) 
            {
              this.CourseTypes[i].value = this.CourseTypes[i].name;
              tmpCourseTypes.push(this.CourseTypes[i]);
            }
          }
          this.CourseTypes = tmpCourseTypes;
        }
      });
    }
  }
}

</script>
<style lang="scss" scoped>
.section1 {
  background-color: rgba(101, 20, 171, 1);
  border-radius: 35px;
  height: 71px;
  width: 538px;
  padding: 28px 0 0 231px;
  margin:auto;
  margin-top: 30px;
}
.info1 {
  width: 75px;
  height: 17px;
  overflow-wrap: break-word;
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  font-family: PingFang-SC-Medium;
  text-align: left;
  white-space: nowrap;
  line-height: 18px;
  display: block;
}
h3{ 
  color: #fff;
  margin-bottom: 25px;
}

.search-container {
text-align: center;
  background: url(/static/images/bg.png);
  background-repeat: no-repeat;
  background-size: cover;
  box-sizing: border-box;
  height: 100vh;
      padding: 5rem 0.5rem 0;
    width: 100%;
}
.logo_svg {
    height: 3.75rem;
    margin: 0 3.85rem 3.3rem;
    width: 11.05rem
}

.search {
    position: relative;
}
.el-scrollbar {
    > .el-scrollbar__bar {
        opacity: 1 !important;
    }
}
::v-deep .el-scrollbar__bar{
  opacity: 1 !important;
}
.logo_svg{
    height: 11.75rem;
    margin: 0 0.85rem 3.3rem;
    width: 11.05rem;
}
::v-deep .submit .el-form-item__content{
  margin-left: 0px !important;
}
@media screen and (min-width: 640px){
  .box-card{
    width: 40%;
    margin:auto;
  }
}

</style>